var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyGraphicsTabIcon = function SvgEmptyGraphicsTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3D4355",
    clipPath: "url(#EmptyGraphicsTabIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.75,
    height: 9.692,
    x: 6.499,
    y: 10.654,
    fill: "#F3F4FE",
    rx: 4.846
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "M18.975 25.027a.81.81 0 0 1 1.157-.103l24.193 20.661c.575.49.228 1.43-.527 1.43H2.714a.812.812 0 0 1-.63-1.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4FE",
    d: "M35.339 20.838a.813.813 0 0 1 1.313.008l17.921 24.882a.813.813 0 0 1-.659 1.287H17.611a.813.813 0 0 1-.654-1.295z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 41,
    x: 0.5,
    y: 5.5,
    stroke: "#3D4355",
    rx: 7.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EmptyGraphicsTabIcon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 42,
    y: 5,
    fill: "#fff",
    rx: 8
  })))));
};
export default SvgEmptyGraphicsTabIcon;